module.exports = __webpack_public_path__ + "img/amazon.d2a29027.svg";